import * as React from 'react';
import { useState } from 'react';
import { rgba } from 'polished';
import styled, { keyframes, useTheme } from 'styled-components';
import { Anchor, Flex, Text, Logo } from '../../../components/blocks';

import Img from '../../../images/banner/release-campaign.png';

const Motion = keyframes`
  0% {
    transform: translateX(100vw);
  }
  80% {
    transform: translateX(-20px);
  }
  100% {
    transform: translateX(0px);
  }
`;

const Root = styled.div`
  position: fixed;
  z-index: 10;
  bottom: 24px;
  right: 16px;
  padding: ${({ theme }) => theme.spaces.xl};
  background: ${({ theme }) => rgba(theme.backgroundColors.primary, 0.9)};
  border: 2px solid ${({ theme }) => theme.borderColors.white};
  border-radius: ${({ theme }) => theme.radii.l};
  backdrop-filter: blur(2px);
  box-shadow: ${({ theme }) => theme.boxShadow.base};
  transform: translateX(100vw);
  animation: ${Motion} 0.6s ease-in-out 1;
  animation-fill-mode: forwards;
  animation-delay: 4s;

  &.close {
    display: none;
  }

  ${({ theme }) =>
    theme.screen.sp({
      bottom: '80px',
      left: '8px',
      right: '8px',
      width: 'calc(100% - 16px)',
      padding: `${theme.spaces.m} ${theme.spaces.l}`,
    })}
`;

const CloseButton = styled.div`
  position: absolute;
  top: -8px;
  right: -8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: ${({ theme }) => theme.radii.circle};
  background: ${({ theme }) => theme.backgroundColors.black};
  transform: rotate(45deg);
  transition-duration: ${({ theme }) => theme.transitions.normal};
  cursor: pointer;

  &:hover {
    opacity: 0.8;
    transform: scale(1.1) rotate(45deg);
  }

  &:before {
    position: absolute;
    content: '';
    width: 14px;
    height: 2px;
    background-color: ${({ theme }) => theme.backgroundColors.white};
  }

  &:after {
    position: absolute;
    content: '';
    width: 2px;
    height: 14px;
    background-color: ${({ theme }) => theme.backgroundColors.white};
  }
`;

const Wrapper = styled(Flex)`
  ${({ theme }) =>
    theme.screen.sp({
      fontSize: theme.fontSizes.xxs,
      flexDirection: 'row',
      justifyContent: 'center',
    })}
`;

const Title = styled(Text)`
  ${({ theme }) =>
    theme.screen.sp({
      fontSize: theme.fontSizes.xs,
      textAlign: 'left',
    })}
`;

const Image = styled.img`
  margin-bottom: ${({ theme }) => theme.spaces.xl};

  ${({ theme }) =>
    theme.screen.sp({
      marginBottom: theme.spaces.s,
      width: '160px',
    })}
`;

const OverrideAnchor = styled(Anchor)`
  ${({ theme }) =>
    theme.screen.sp({
      fontSize: theme.fontSizes.xs,
      padding: theme.spaces.m,
    })}
`;

const Content = styled(Flex)`
  ${({ theme }) =>
    theme.screen.sp({
      alignItems: 'flex-start',
    })}
`;

const ImageWrap = styled(Flex)`
  gap: ${({ theme }) => theme.spaces.l};
  ${({ theme }) =>
    theme.screen.sp({
      gap: theme.spaces.s,
    })}
`;

export const FixedBanner: React.FC = () => {
  const theme = useTheme();

  const [isClose, setIsClose] = useState(false);

  const close = () => {
    setIsClose(!isClose);
  };

  return (
    <>
      {!isClose && (
        <Root>
          <CloseButton onClick={close} />
          <Wrapper
            flexDirection="column"
            alignItems="center"
            gap={theme.spaces.l}
          >
            <Content
              flexDirection="column"
              alignItems="center"
              gap={theme.spaces.l}
            >
              <Logo color="white" width="auto" height="auto" />
              <Title
                color="white"
                fontWeight="bold"
                size="xl"
                textAlign="center"
                lineHeight="m"
              >
                リリース記念
                <br />
                キャンペーン実施中
              </Title>
            </Content>
            <ImageWrap flexDirection="column" alignItems="center">
              <Image src={Img} width="200" height="auto" alt="特別価格画像" />
              <OverrideAnchor
                color="secondary"
                to="/form/inquiry"
                radius="rounded"
              >
                お問い合わせ
              </OverrideAnchor>
            </ImageWrap>
          </Wrapper>
        </Root>
      )}
    </>
  );
};
